// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1A5fD","inputWrap":"styles_inputWrap__3W20E","input":"styles_input__1PpLv"};